import * as React from 'react';

export interface RollingProps {
    onRoll: (dx: number, dy: number) => void;
    className?: string;
}

export interface RollingState {
    lastX: number;
    lastY: number;
}

export default class Rolling extends React.Component<RollingProps, RollingState> {
  constructor(props: RollingProps) {
    super(props);

    this.state = {
        lastX: 0,
        lastY: 0
    }
  }

    handleMoving = (e) => {

        this.setState({ lastX: e.screenX, lastY: e.screenY });

        this.props.onRoll(e.clientX, e.clientY);
    }

    public width: number;

  public render() {
    return (
      <div className={this.props.className} ref={e => {
          if(e)
            this.width = e.offsetWidth;
      }} onMouseMove={this.handleMoving}>
          {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/ui/rolling.tsx